export default __webpack_public_path__ + "static/media/bakof-tec.26eaf783.png";